import { AxiosInstance } from 'axios'

import { useWebapiClient } from '../use-webapi-client'

export const useMutationOptionsWithVariables = <Key, MutationResponse, Variables, MappedResponse>(
  mutationFn: (webapiClient: AxiosInstance, variables: Variables) => Promise<MutationResponse>,
  mapFn?: (response: MutationResponse) => MappedResponse,
  mutationKey?: Key[],
  variables?: Variables
) => {
  const webapiClient = useWebapiClient()
  return {
    mutationKey: [mutationKey, variables],
    mutationFn: (variables: Variables) => mutationFn(webapiClient, variables).then(mapFn),
  }
}
